import { useState, useEffect, useRef } from 'react'
import axios from 'axios'
import ReactPlayer from 'react-player'
import { motion, useMotionValue, useTransform, animate } from "framer-motion";

import Container from 'react-bootstrap/Container';
import Carousel from 'react-bootstrap/Carousel';
import 'bootstrap/dist/css/bootstrap.min.css';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { Whatsapp, Telephone } from 'react-bootstrap-icons';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal'
import { isMobile } from 'react-device-detect';

import logo from './img/logo.png';
import bannerHome from './img/banner-home.jpg'
import team from './img/team.jpg'
import mapa from './img/mapa.png'
import idea from './img/idea.png'
import staff from './img/staff.png'
import caballo from './img/caballo.png'
import footerTitle from './img/footer-title.png'
import send from './img/send.png'

import servicio01 from './img/servicio01.jpg'
import servicio02 from './img/servicio02.jpg'
import servicio03 from './img/servicio03.jpg'
import servicio04 from './img/servicio04.jpg'
import servicio05 from './img/servicio05.jpg'
import servicio06 from './img/servicio06.jpg'

import liverpool from './img/liverpool.png'
import little from './img/little.png'
import tim from './img/tim.png'
import plaza from './img/plaza.png'
import ideas from './img/ideas.png'
import helvex from './img/helvex.png'

import insta from './img/insta.png'
import face from './img/face.png'
import linked from './img/in.png'
import tik from './img/tik.png'
import youtube from './img/youtube.png'

import './App.css';
import 'animate.css';

function Home({ refHome, refTeam, refServices, refClients, refContact }) {

  const [isLoading, setLoading] = useState(false)
  const [name, setName] = useState("")
  const [phone, setPhone] = useState("")
  const [email, setEmail] = useState("")
  const [comments, setComments] = useState("")

  const [showMessage, setShowMessage] = useState(false)
  const [title, setTitle] = useState('')
  const [message, setMessage] = useState('')

  const citiesCount = useMotionValue(0);
  const yearsCount = useMotionValue(0);
  const teamsCount = useMotionValue(0);
  const staffCount = useMotionValue(0);

  const cities = useTransform(citiesCount, Math.round);
  const years = useTransform(yearsCount, Math.round);
  const teams = useTransform(teamsCount, Math.round);
  const staffPeople = useTransform(staffCount, Math.round);

  /*useEffect(() => {
    if( window.location.pathname == '/gracias' ) {
      setLoading(false)
      setTitle("Mensaje enviado")
      setMessage("Tu mensaje ha sido enviado. En breve nos comunicaremos contigo. Gracias.");
      handleShow()

      console.log("from gtag called")
      window.gtag('event', 'conversion', {
        'send_to': 'AW-17106052149/eEywCPCh788aELXI5tw_',
        'value': 1.0,
        'currency': 'MXN'
      });
    }
  })*/

  useEffect(() => {
    const loadScriptByURL = (id, url, callback) => {
      const isScriptExist = document.getElementById(id);
 
      if (!isScriptExist) {
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.src = url;
        script.id = id;
        script.onload = function () {
          if (callback) callback();
        };
        document.body.appendChild(script);
      }
 
      if (isScriptExist && callback) callback();
    }
 
    // load the script by passing the URL
    loadScriptByURL("recaptcha-key", `https://www.google.com/recaptcha/api.js?render=6Lfay-sgAAAAAKMr9fFh6dAgAQ72hqP64TVuAAk5`, function () {
      console.log("Script loaded!");
    });
  }, []);

  const handleShow = () => setShowMessage(true);
  const handleOnSubmit = (event) => {
    event.preventDefault();
    
    window.grecaptcha.ready(() => {
      window.grecaptcha.execute("6Lfay-sgAAAAAKMr9fFh6dAgAQ72hqP64TVuAAk5", { action: 'submit' }).then(token => {
        //if(isVerified){
        setLoading(true);
        //const recaptchaValue = recaptchaRef.current.getValue();
        var form = document.getElementById("contactForm");
        var formData = new FormData(form);
        formData.append('recaptcha_response', token);

        setLoading(true);
        axios.post("https://inmobiplace.com/api/contactMG", formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
          }).then(function(response) {

            if(response.data == "FAIL" || response.data == "ERROR") {
              setLoading(false)
              setTitle("Error")
              setMessage("Ocurrió un error al intentar enviar tu mensaje, por favor intenta mas tarde.");
              handleShow()
            } else {
              //window.location.href = "/gracias"
              setLoading(false)
              setTitle("Mensaje enviado")
              setMessage("Tu mensaje ha sido enviado. En breve nos comunicaremos contigo. Gracias.");
              handleShow()

              setName("");
              setPhone("");
              setEmail("");
              setComments("");
            }

          }).catch(function(err) {
            setLoading(false)
            setTitle("Error")
            setMessage("Ocurrió un error al intentar enviar tu mensaje, por favor intenta mas tarde.");
            handleShow()
          });
      //} else 
        //alert("Por favor, verifica que no eres un robot")
      });
    });
  }

  const closeModalSent = () => {
    /*if( title == 'Error') setShowMessage(false)
    else window.location.href = "/"*/
    setShowMessage(false)
  }

  return (
    <>

      <Modal show={showMessage} onHide={ () => closeModalSent() }>
        <Modal.Header style={{ background: "#fff" }} closeButton>
          <Modal.Title style={{ color: "#000" }}>{ title }</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ color: "#000", background: "#fff" }}>{ message }</Modal.Body>
        <Modal.Footer style={{ color: "#000", background: "#fff" }}>
          <Button variant="secondary" onClick={ () => closeModalSent() }>
            Aceptar
          </Button>
        </Modal.Footer>
      </Modal>

      <div className="App">
        <div ref={refHome}>
          {/* <img src={bannerHome} className='banner-home'/> */}
          <div style={{ height: '110px' }} />
          <ReactPlayer className="player-v" url='mgp.mp4' playing={ true } loop={ true } volume={ 0 } muted={ true } controls={ true } />
        </div>

        <div ref={ refServices } className='banner-us'>
          <Container>
            <Row className='align-items-center'>
              <Col>
                <div className='home-title-black'> SERVICIOS / UNIDADES DE NEGOCIO </div>
              </Col>
            </Row>
          </Container>
        </div>

        <div className='section'>
          <Container>
            <Row>
              <Col>
                <Carousel fade indicators={false} pause={false}>
                  <Carousel.Item>
                    <a href="/btl"> <img src={ servicio01 } className='service-carousel'/> </a>
                  </Carousel.Item>
                  <Carousel.Item>
                    <a href="/ooh"> <img src={ servicio02 } className='service-carousel'/> </a>
                  </Carousel.Item>
                  <Carousel.Item>
                    <a href="/print"> <img src={ servicio03 } className='service-carousel'/> </a>
                  </Carousel.Item>
                  <Carousel.Item>
                    <a href="/medios"> <img src={ servicio04 } className='service-carousel'/> </a>
                  </Carousel.Item>
                  <Carousel.Item>
                    <a href="/arquitectura"> <img src={ servicio05 } className='service-carousel'/> </a>
                  </Carousel.Item>
                  <Carousel.Item>
                    <a href="/experience"> <img src={ servicio06 } className='service-carousel'/> </a>
                  </Carousel.Item>
                </Carousel>
              </Col>
            </Row>
          </Container>
        </div>

        <div ref={ refTeam } className='section'>
          <Container>
            <div className='home-title-black'> TEAM </div>
            <div className='home-title-medium'> Somos </div>
            <div className='home-title-black'> MG PUBLICIDAD </div>
          </Container>

          <Container>
            <img src={team} className='team-img'/>
          </Container>
        </div>
    
        <div className='section section-numeralia'>
          <Container >
            <Row>
              <Col md={ 3 } xs={ 6 }>
                <div align="center" className='mb-3'>
                  <div><img src={ mapa } className='numeralia-icon' /></div>
                  <div className='numeralia-title'> +<motion.span initial="hidden" whileInView={ () => animate(citiesCount, 31, {duration: 2 }) } viewport={{ once: true }}>{ cities }</motion.span> </div>
                  <div className='numeralia-desc'> <div className='numeralia-desc-bold'> CIUDADES OPERANDO </div> a lo largo de toda la República Mexicana </div>
                </div>
              </Col>
              <Col md={ 3 } xs={ 6 } className='mb-3'>
                <div align="center">
                  <div><img src={ idea } className='numeralia-icon' /></div>
                  <div className='numeralia-title'> +<motion.span initial="hidden" whileInView={ () => animate(yearsCount, 16, {duration: 2 }) } viewport={{ once: true }}>{ years }</motion.span> </div>
                  <div className='numeralia-desc'> <div className='numeralia-desc-bold'> AÑOS CREANDO </div> <div className='numeralia-big'>IDEAS</div> </div>
                </div>
              </Col>
              <Col md={ 3 } xs={ 6 } className='mb-3'>
                <div align="center">
                  <div><img src={ caballo } className='numeralia-icon' /></div>
                  <div className='numeralia-title'> +<motion.span initial="hidden" whileInView={ () => animate(teamsCount, 50, {duration: 2 }) } viewport={{ once: true }}>{ teams }</motion.span> </div>
                  <div className='numeralia-desc'> <div className='numeralia-desc-bold'> ALIANZAS ESTRATÉGICAS </div> con empresas claves en el giro </div>
                </div>
              </Col>
              <Col md={ 3 } xs={ 6 } className='mb-3'>
                <div align="center">
                  <div><img src={ staff } className='numeralia-icon' /></div>
                  <div className='numeralia-title'> +<motion.span initial="hidden" whileInView={ () => animate(staffCount, 200, {duration: 2 }) } viewport={{ once: true }}>{ staffPeople }</motion.span> </div>
                  <div className='numeralia-desc'> <div className='numeralia-desc-bold'> PERSONAS EN STAFF </div> materializando tus ideas </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>

        <div ref={ refClients } className='section'>
          <div className='home-title-black'> NUESTROS CLIENTES </div>
          <Container>
            <Row>
              <Col>
                <Carousel data-bs-theme="dark" pause={false}>
                  <Carousel.Item>
                    <div align="center"><img src={ plaza } className='client-img'/></div>
                  </Carousel.Item>
                  <Carousel.Item>
                    <div align="center"><img src={ liverpool } className='client-img'/></div>
                  </Carousel.Item>
                  <Carousel.Item>
                    <div align="center"><img src={ little } className='client-img'/></div>
                  </Carousel.Item>
                  <Carousel.Item>
                    <div align="center"><img src={ tim } className='client-img'/></div>
                  </Carousel.Item>
                  <Carousel.Item>
                    <div align="center"><img src={ ideas } className='client-img'/></div>
                  </Carousel.Item>
                  <Carousel.Item>
                    <div align="center"><img src={ helvex } className='client-img'/></div>
                  </Carousel.Item>
                </Carousel>
              </Col>
            </Row>
          </Container>
        </div>

        <div ref={refContact} className='footer section'>
        <div align="center">
          <div className='contact-container'>
          <Container>
            <div align="center"> <img src={logo} height="90" className="d-inline-block" /> </div>
            <br/>
            <Row className='align-items-center'>
              <Col md={ 8 }>
                <div> <img src={ footerTitle } className='team-img' /> </div>
              </Col>
              <Col md={ 4 }>
                <div className='footer-team'> HAGAMOS EQUIPO </div>
              </Col>
            </Row>
            <br/><br/>
            <Row>
              <Col md={ 7 } xs={ 12 }>
                <div className='form-container'>
                  <div className='footer-title'> COMENCEMOS A TRABAJAR JUNTOS </div>
                  <Form id="contactForm" onSubmit={ handleOnSubmit }>
                    <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                      <Form.Label></Form.Label>
                        <Form.Control required type="text" className='form-footer' placeholder="Nombre:" name='name' value={ name } onChange={ () => setName()}/>
                        <Form.Control required type="email" className='form-footer' placeholder="Email:" name='email' value={ email } onChange={ () => setEmail()}/>
                        <Form.Control required type="number" className='form-footer' placeholder="Teléfono:" name='phone' value={ phone } onChange={ () => setPhone()}/>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                      <Form.Control required as="textarea" className='form-footer' placeholder="Mensaje:" rows={3} name='comments' value={ comments } onChange={ () => setComments()}/>
                    </Form.Group>
                      <div align="right"><Button disabled={isLoading} className="button-footer" type="submit" >{isLoading ? 'Enviando…' : 'ENVIAR'}</Button></div>
                  </Form>
                  <div><a href='mailto:contacto@mgpublicidad.mx'><div className='footer-text-link'>contacto@mgpublicidad.mx</div></a></div>
                </div>
              </Col>
              <Col md={ 5 } xs={ 12 } className='footer-text-desc' align="center">
                <div>

                  <div className='suscribe-container'>
                    <div>
                      <Form id="contactForm" onSubmit={ handleOnSubmit }>
                        <Container>
                          <Row>
                            <div className='footer-title' style={{ fontSize: '20px' }} align='left'> SUSCRÍBETE </div>
                          </Row>
                          <Row className='align-items-center mt-2'>
                            <Col md={ 11 } style={{ borderBottom: '1px solid #fff' }}>
                              <Form.Group>
                                <Form.Control required type="text" className='form-footer form-footer-italic' placeholder="Dirección de Correo" name='name' value={ name } onChange={ () => setName()}/>
                              </Form.Group>
                            </Col>
                            { !isMobile && 
                              <Col md={ 1 }>
                                <div> <img src={send} className='footer-icon'/> </div>
                              </Col>
                            }
                          </Row>
                          <Row>
                            <Col>
                              <br/>
                              <div align="left">
                                <Form.Check
                                  type={'radio'}
                                  label={`Acepto los términos y condiciones`}
                                />
                              </div>
                            </Col>
                          </Row>
                        </Container>
                      </Form>
                    </div>
                  </div>
                  <br/>

                  <Container>
                    <Row>
                      <Col md={ 1 } xs={ 0 } />
                      <Col md={ 2 } xs={ 2 }> <a href="https://www.facebook.com/AgenciaMGPublicidad/" target='_blank'> <img src={ face } className='rrss-icons' /> </a> </Col>
                      <Col md={ 2 } xs={ 2 }> <a href="https://www.instagram.com/agenciamgpublicidad/?igshid=a7zcmnd5sg1y" target='_blank'> <img src={ insta } className='rrss-icons' /> </a> </Col>
                      <Col md={ 2 } xs={ 2 }> <a href="https://www.youtube.com/@agenciamgpublicidad3543" target='_blank'> <img src={ youtube } className='rrss-icons' /> </a> </Col>
                      <Col md={ 2 } xs={ 2 }> <a href="https://www.tiktok.com/@agenciamgpublicidad" target='_blank'> <img src={ tik } className='rrss-icons' /> </a> </Col>
                      <Col md={ 2 } xs={ 2 }> <a href="https://mx.linkedin.com/company/mg-promociones" target='_blank'> <img src={ linked } className='rrss-icons' /> </a> </Col>
                      <Col md={ 1 } xs={ 0 } />
                    </Row>
                    <Row>
                      <Col>
                        <br/>
                        <div className='footer-text-desc mb-2' ><a href='tel:5568237495' target='_blank' > <Telephone /> &nbsp;&nbsp;55 6823 7495 </a></div>
                        <div className='footer-text-desc' ><a href='https://wa.me/5580947307' target='_blank' > <Whatsapp /> &nbsp;&nbsp;55 8094 7307 </a></div>
                      </Col>
                    </Row>
                  </Container>
                </div>
              </Col>
            </Row>
          </Container>
          </div>

          <Container>
            <br/>
            <Row className='line-footer' />
            <br/>
            <Row className='align-items-center' align="center">
              <Col md={4} sx={12} style={{ cursor: 'pointer' }}>
                { isMobile && <br/> }
                <a href='/'> <div align={ isMobile ? "center" : "left" }><img src={logo} width={90 }/></div> </a>
                { isMobile && <br/> }
              </Col>
              <Col md={4} sx={12} className='footer-text-desc' style={{ cursor: 'pointer' }} >
              </Col>
              <Col md={4} sx={12}> 
                <div align={ isMobile ? "center" : "right" }>
                  <a href='https://mgmarketinggroup.com.mx/' target='_blank'><div className='footer-team'> By Marketing Group </div></a>
                </div>
              </Col>
            </Row>
            
          </Container>
        </div>

      </div>
    </div>

    </>
  );
}

export default Home;
